import React from 'react';
import {
    withStyles,
    AppBar,
    Typography,
    Toolbar,
    Grid,
} from '@material-ui/core';

import MBackIcon from './MBackIcon';
import MStatusBar from './MStatusBar';

class MHeader extends React.Component {

    render() {
        const { classes, hideBack, } = this.props;
        return (
            <Grid container direction='column' direction='column' alignItems='center'>
                <MStatusBar />
                <div className={classes.root}>
                    <AppBar position='relative' className={classes.appbar} style={{backgroundColor:this.props.appBarColor, boxShadow: this.props.appBarColor != '#FC4545'?'1px 1px 1px #F0F0F0':'0 0 0 #F0F0F0',}}>
                        <Toolbar style={{ justifyContent: 'center', alignItems: 'center', width: '100%', paddingLeft: 0, paddingRight: 0 }}>
                            {
                                !hideBack && <MBackIcon  appBarColor={this.props.appBarColor}/>
                            }
                            {
                                this.props.appBarColor != '#FC4545' &&
                                <Typography className={classes.titleText}>{this.props.title}</Typography>
                            }
                            {this.props.titlechildren}
                        </Toolbar>
                    </AppBar>
                </div>
            </Grid>

        );
    }
}

export default withStyles((theme) => ({
    root: {
        backgroundSize: 'cover',
        backgroundColor: 'transparent',
        display: "flex",
        flexDirection: 'column',
        alignItems: 'center',
        height: 48,
        width: '100vw',
    },
    appbar: {
        backgroundColor: '#FFF',
        flexDirection: 'rows',
       
        justifyContent: 'center',
        width: '100%'
    },
    titleText: {
        fontSize: 17,
        color: '#0D0D0D',
        fontWeight: 'bold',
    },
}))(MHeader);